import React, { Component } from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'

import ScrollIntoView from 'components/ScrollIntoView'
import CookieConsentComponent from 'components/CookieConsentComponent'
import Home from './routes/Home/components/View'
import Currency from './routes/Currency/components/View'
import Contact from './routes/Contact/components/View'
import CookiePolicy from './routes/CookiePolicy/components/View'
import Error from './routes/Error/components/View'

import ReactGA from 'react-ga'

ReactGA.initialize(process.env.REACT_APP_GA_ID)
ReactGA.pageview(window.location.pathname + window.location.search)

class App extends Component {
	render() {
		return <BrowserRouter>
			<ScrollIntoView>
				<CookieConsentComponent />
				<Switch>
					<Route exact path="/" render={() => {
						return <Home mode='monetary'/>}} />
					<Route exact path="/currencies" render={() => {
						return <Home mode='monetary'/>}} />
					<Route exact path="/cryptocurrencies" render={() => {
						return <Home mode='crypto'/>}} />
					{/*Single currency route*/}
					{[
						'/currencies/calculator/:currencyParam',
						'/currencies/graphics/:currencyParam',
						'/currencies/rates/:currencyParam'
					].map((path, index) =>
						<Route exact path={path} key={index} render={(props) => {
							return <Currency mode='monetary' {...props} />}} />
					)}
					{/*Single crypto currency route*/}
					{[
						'/cryptocurrencies/calculator/:currencyParam',
						'/cryptocurrencies/graphics/:currencyParam',
						'/cryptocurrencies/rates/:currencyParam'
					].map((path, index) =>
						<Route exact path={path} key={index} render={(props) => {
							return <Currency mode='crypto' {...props} />}} />
					)}
					<Route exact path="/contact" component={Contact}/>
					<Route exact path="/cookie-policy" component={CookiePolicy}/>
					<Route exact path="/*" component={Error}/>
				</Switch>
			</ScrollIntoView>
		</BrowserRouter>
	}
}

export default App
